import { finish, error } from '../../../modules/user/actions/change-password';

import api from '../../../api';

export function request(dispatch, action) {
    api.post('/user/change-password', {
        password: action.password,
        old: action.old
    }).then(
        () => dispatch(finish()),
        ({ errors }) => dispatch(error(errors))
    );
}
